import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-pile-renamer',
  templateUrl: './pile-renamer.page.html',
  styleUrls: ['./pile-renamer.page.scss'],
})
export class PileRenamerPage implements OnInit,AfterViewInit {
    @Input() pileNumber: string;
    @Input() uid: string;
    @Input() pileNumbers:string[];
    newNumber:string;
    public form: FormGroup;
  constructor(private formBuilder: FormBuilder,public modalController: ModalController ) {
    this.form = this.formBuilder.group({ newNumber: ['', [
      Validators.required,
      this.validPileNumberValidator.bind(this),
      this.allowedNumberValidator.bind(this)
    ]]});
  }
  setInput(event:any){
    this.form.controls['newNumber'].setValue(event.detail.target.value);
  }
  ngAfterViewInit(): void {
    console.log(this.form.controls)

  }

  ngOnInit() {
    console.log('ngOnInit')
    // console.log(this.pileNumbers,this.pileNumber,this.form.controls.newNumber)
  }
  validPileNumberValidator(control:FormControl){
    let value = control.value;
    if(!value) return null;
    value = value.toUpperCase();
    if(!/^\d+[ABC]?$/.test(value)){
      return {
        newNumber: {
          invalid: 'Invalid pile number.'
        }
      }
    }
    return null;
  }
  allowedNumberValidator( control:FormControl){
    let value = control.value;
    if(!value) return null;
    if(this.pileNumbers.includes(value)){
      return {
        newNumber: {
          exists: 'New number already exists.'
        }
      }
    }
    return null;

  }
  save(){
    console.log('save',this.form.value)
    if(!this.form.valid) return this.cancel();
    this.newNumber = this.form.value.newNumber.toUpperCase();
    this.modalController.dismiss({
      changed: true,
      newNumber: this.newNumber,
      newUID: this.uid.replace( new RegExp(this.pileNumber), this.newNumber),
      pileNumber: this.pileNumber,
      uid: this.uid
    });
  }
  isChanging(event:any){
    console.log('isChanging',event)
  }
  cancel() {
     // using the injected ModalController this page
     // can "dismiss" itself and optionally pass back data
     this.modalController.dismiss({
       changed: false,
       // newNumber: this.newNumber,
       // newUID: this.uid.replace( new RegExp(this.pileNumber), this.newNumber),
       pileNumber: this.pileNumber,
       uid: this.uid
     });
   }
}
